class NetworkError extends Error {
  constructor(
    readonly statusCode: number,
    readonly key: string | number,
    ...args: any
  ) {
    super(...args);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NetworkError);
    } else {
      this.stack = new Error().stack;
    }

    this.statusCode = statusCode;
    this.key = key;
  }
}

export default NetworkError;
